<template>
<van-popup
  v-model="commentShow"
  closeable
  get-container="body"
 class="popupCommentStyle"
 :lock-scroll="false"
  position="bottom"
  :style="{ height: '70%' }">
     <van-overlay :show="overlayShow" @click="show = false" z-index="9999"/>
  <div class="popupCommentTitle font-28  cor-33 p-24 text-center">评论</div>
  <div class="popupCommentBox rela">
    <div class="p-b-90 popupCommentListBox">
        <div class="flex col-top p-t-24 p-l-24 p-r-24" v-for="commentItem in commentList" :key="commentItem.commentId">
          <div class="w-60 h-62 m-r-16">
              <img src="@/assets/icon/feedbackStatistics/avatarNon.png" alt="项目" class="width-100 height-100">
              <!-- <img :src="commentItem.avatar?`${commentItem.avatar}`:'@/assets/icon/feedbackStatistics/avatarNon.png'" alt="项目" class="width-100 height-100"> -->
          </div>
          <div class="flex-1">
              <div class="font-24 cor-99">{{commentItem.createName}}</div>
              <div class="font-28 cor-33 p-t-8  p-b-8">{{commentItem.message}}</div>
              <div class="font-24 cor-99">{{commentItem.createTime}}</div>
          </div>
      </div>
    </div>
    <van-cell-group class="flex row-center col-center abso pos-b-0 width-100 p-l-24 p-r-24">
      <div class="font-28 w-60 h-56 l-h-54 text-center userClickBtn b-r-100" @click="deptUserTreeAll.show = true">@</div>
      <van-popup v-model="deptUserTreeAll.show" get-container="body" position="bottom">
        <van-nav-bar left-text="取消" right-text="确定" title="选择人员"
                      @click-left="deptUserTreeAll.show = false" @click-right="commentPopupSubmit"
        />
        <van-search v-model="deptUserTreeAll.filterText" clearable shape="round"
                    @input="treeSearch($event, $refs.tree)"
        />
        <div class="h-vh-50" style="overflow-y: auto">
          <div class="p-10">
            <el-tree ref="tree" :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                      check-strictly node-key="uuid" show-checkbox
            />
          </div>
        </div>
      </van-popup>

      <van-field :border="true" v-model="commentForm.message" center clearable type="textarea" autosize
                  placeholder="请输入评论内容" class="p-l-26 p-r-0 p-t-20 p-b-20 " @input="handleInput"  >
        <template #button>
          <van-button @click="sendComment" size="small" icon="comment-o" round
                      type="primary">发送
          </van-button>
        </template>
      </van-field>
    </van-cell-group>
        <!-- <van-textarea v-model="commentContent" style="width:100%" placeholder="请输入评论内容"></van-textarea>
<van-button  color="primary">发送</van-button> -->
      </div>
</van-popup>
</template>

<script>
import {methodGetApi} from "@/api/publicApi";
import {Toast} from 'vant';
import {getDeptUserTreeAll} from '@/api/user.js'
import { saveCommentAPI} from '@/api/task.js';
import mixin from '@/mixin/flow'
export default {
  name: 'commentForm',
  mixins: [mixin],
  inject: ['feedbackReceivedViewProvide'],
  data() {
    return {
        commentShow:false,
        overlayShow:false,
        commentForm: {
            message: '',
            taskId: '',
            userInfo: []
        },
        // 部门用户树
        deptUserTreeAll: {
            data: [],
            filterText: '',
            show: false
        },
        commentList:[]
    }
  },

  created() {
  },
  mounted() {
      this.getDeptUserTreeAll()
   
  },
  methods: {
  // 过滤表情符号的方法 - 只允许汉字、大小写英文字母、@符号和数字
  filterEmoji(str) {
  // 只保留汉字、大小写英文字母、数字、@符号、空格和常见标点符号，其他字符全部过滤掉
  const allowedRegex = /[^\u4e00-\u9fa5a-zA-Z0-9@\s，。！？；：""''（）【】《》、,.!?;:"'()\[\]<>、·]/g;
  return str.replace(allowedRegex, '');
  },
  
  // 处理输入事件
  handleInput(value) {
    // 过滤表情符号并更新模型
    const filteredValue = this.filterEmoji(value);
    if (filteredValue !== value) {
      this.commentForm.message = filteredValue;
    }
  },
     //跳转详情
     getTaskComment(taskId) {
      this.commentForm.taskId = taskId
        let url = '/task/taskComment/list'
       let data={
          taskId:taskId,
          pageSize:10000,
       }
        // 获取第一页数据
         methodGetApi(url,data).then(async res => {
            this.commentList=res.rows
           
        })
    },
  // 人员、部门树
    getDeptUserTreeAll() {
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
        })
      })
    },
        // 发表评论
    sendComment() {
      console.log(this.commentForm)
      if (this.commentForm.message.trim() == '') {
        Toast.fail("请输入评论内容");
      } else {
        this.overlayShow=true
        saveCommentAPI(this.commentForm).then(res => {
          if (res.code == 200) {
            Toast.success("评论成功");
            this.commentForm.message = '';
             this.overlayShow=false
            this.getTaskComment(this.commentForm.taskId);
            // this.feedbackReceivedViewProvide.dataInit()
          }
        })
      }
    },
    commentPopupSubmit() {
      let comment = ''
      const data = this.$refs.tree.getCheckedNodes()
      // 去重
      const existingUserIds = this.commentForm.userInfo.map(user => user.id);
      const uniqueData = data.filter(item => !existingUserIds.includes(item.id));
      this.commentForm.userInfo.push(...uniqueData)
      uniqueData.forEach(item => {
        comment += ('@' + item.label)
      })
      this.commentForm.message += comment
      this.deptUserTreeAll.show = false
    },
    // 过滤节点
    filterNode(value, data) {
        if (!value) return true;
        return data.label ? data.label.indexOf(value) !== -1 : data.name.indexOf(value) !== -1;
    },
    // 用于管理动态table中的treeSearch
    treeSearch(text, treeDom) {
        let dom = treeDom.length ? treeDom[0] : treeDom
        dom.filter(text);
    },
  }
}
</script>
<style lang="less" >
.popupCommentStyle{
  overflow: hidden;
  .popupCommentTitle{
    border: 2px solid #e5e5e5;
    font-weight: bold;
  }
  .popupCommentBox{
    height: calc(100% -  140px);
  }
  .popupCommentListBox{
    height: calc(100% - 90px);
    overflow: auto;
  }
    .van-popup__close-icon--top-right{
      top: 30px;
      right: 24px;
    }
    .van-icon{
      font-size: 32px;
      color: #333;
    }
    .userClickBtn{
      background:#FFDA3E;
    }
    .van-field__control{
      border: 1px solid #DBDBDB;
      padding: 2px 8px;
      border-radius: 2px;
    }
}
</style>
